<template>
    <div class="mt-5 mb-5">
        <BOverlay :show="is_loading">
            <div ref="pos_items" id="positions_item" style="height:600px;display: block"></div>
        </BOverlay>
        
        
        <div class="row mt-5">
            <div class="col-xl-9 col-lg-9 col-sm-8 col-xs-12">
                <div class="container-fluid">
                    <div class="row height38">
                        <div class="col-2">Cума без ПДВ:</div>
                        
                        <div class="summ_app col-3">{{ fmtUA(totals.sumUAH) }} грн.</div>
                        
                        <div class="col-sm-3">
                            <input
                                :disabled="only_view"
                                type="radio"
                                value="1"
                                v-model="request.has_pdv" /> ПДВ 20%
                        </div>
                    
                    
                    </div>
                    
                    <div class="row height38">
                        <div class="col-2">ПДВ:</div>
                        <div class="pdv_app col-3">{{ fmtUA(totals.pdv) }} грн.</div>
                        
                        <div class="col-sm-3">
                            <input
                                :disabled="only_view"
                                type="radio"
                                value="2"
                                v-model="request.has_pdv" /> ПДВ 14%
                        </div>
                    
                    </div>
                    
                    <div class="row height38">
                        <div class="col-2">Cума з ПДВ:</div>
                        <div class="summ_pdv_app col-3">{{ fmtUA(totals.total) }} грн.</div>
                        <div class="col-sm-3">
                            <input
                                :disabled="only_view"
                                type="radio"
                                value="3"
                                v-model="request.has_pdv" /> ПДВ 7%
                        </div>
                    </div>
                    
                    <div class="row height38">
                        <div class="col-2"></div>
                        <div class="summ_pdv_app col-3">{{ fmtUA(totals.total) }}</div>
                        <div class="col-sm-3">
                            <input
                                :disabled="only_view"
                                type="radio"
                                value="0"
                                v-model="request.has_pdv" /> Не платник ПДВ
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-xl-3 col-lg-3 col-sm-4 col-xs-12">
                <div class="eur_exchange_rate pb-3" >
                    <div class="form-group">
                        <label class="form-label" for="usd">Курс USD *:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">$</span>
                            </div>
                            
                            <input :disabled="true"  class="form-control" v-model.number="usdRate" />
                        </div>
                    </div>
                </div>
                
                <div class="eur_exchange_rate pb-3 " >
                    <div class="form-group">
                        <label class="form-label" for="euro">Курс EUR *:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">€</span>
                            </div>
                            <input  :disabled="true" class="form-control" v-model.number="eurRate" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>


import * as W2 from 'w2ui'
import {mapGetters} from "vuex";

import {
    BTable,
    BOverlay
} from 'bootstrap-vue-next';

window.w2ui   = W2.w2ui
window.w2grid = W2.w2grid
window.w2field= W2.w2field
window.query  = W2.query
window.w2utils = W2.w2utils

const num = v => Number.parseFloat(v) || 0;
const round2 = v => Math.round(num(v) * 100) / 100;
const mul2 = (a, b) => round2(num(a) * num(b));
const div2 = (a, b) => (num(b) === 0 ? 0 : round2(num(a) / num(b)));

export default {
    name: "application_position",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    components : {
        BOverlay
    },
    
    data() {
        return {
            is_loading : false,
            columns : [],
            positions : [],
            currencies : [],
            
            gridRecords: [],
            only_view : true,
            showUsd: false,
            showEur: false,
            
            totals: { sumUAH: 0, pdv: 0, total: 0 },
        }
    },
    
    created()  {
        this.initW2ui();
    },
    
    methods : {
        async initW2ui() {
            try {
                const { data } = await api.get('/tenders/list/applications/columns')
                if (data.status === "operation_success") {
                    this.columns = data.data || []
                    this.currencies = data.message || []
                    this.initCurrency();
                    this.initGrid()
                }
            } catch (e) {
                console.error(e)
                EventBus.$emit('show_toast', {
                    err: e.response?.data?.message || e.message,
                    type: "danger",
                    title: "error"
                })
            }
        },
        
        initCurrency()
        {
            const currencyItems = (this.currencies || []).map(i => ({
                id: String(i.id),
                text: String(i.text || i.title || '')
            }));
            
            let curIdx = this.columns.findIndex(c => (c.field || c.name) === 'currency_id');
            if (curIdx === -1) curIdx = 10;
            
            const col = this.columns[curIdx];
            col.editable = { type: 'select', items: currencyItems, showAll: true };
            
            col.render = function (record, index, col_index) {
                const val = this.getCellValue(index, col_index);
                const it = (this.columns[col_index].editable.items || []).find(x => String(x.id) === String(val));
                return it ? it.text : '';
            };
        },
        
        initGrid() {
            if (w2ui['positions']) w2ui['positions'].destroy();
            this.fixNumber();
            
            $('#positions_item').w2grid({
                name: 'positions',
                show: {
                    lineNumbers: true,
                    toolbar: true,
                    footer: true
                },
                columns: this.columns,
                records: [],
                toolbar: this.addTollBar()
            })
            
            this.bindEvents();
            this.loadPositions();
            
        },
        
        addTollBar() {
            return {
                items: this.toolBar,
                onClick: (event) => {
                
                }
            }
        },
        
        bindEvents() {
            let self = this;
            w2ui.positions.on("change", function (event) {
                event.preventDefault();
            });
        },
        
        fixNumber() {
            if (window.w2utils && w2utils.formatNumber) {
                const orig = w2utils.formatNumber;
                w2utils.formatNumber = function(val, fraction, useGrouping) {
                    if (useGrouping !== true && useGrouping !== false) {
                        useGrouping = false;  // принудительно boolean
                    }
                    
                    return orig.call(this, val, fraction, useGrouping);
                };
            }
        },
        
        calcParams() {
            this.syncFromGrid();
            this.recalcTotals();
            
            this.checkPricesTour();
            
        },
        
        checkPricesTour() {
            let price_app = 0;
            
            const grid = w2ui.positions;
            if (!grid) return;
            
            const recs = grid.records || [];
            
            recs.forEach((r) => {
                let summ = parseFloat(r.summ) || 0;
                if (!summ) return;
                
                let price_ = parseFloat(r.price_comerc) || 0;
                price_app += price_;
            });
            
            if (price_app === 0) {
                grid.hideColumn('price_comerc');
            } else {
                grid.showColumn('price_comerc');
            }
        },
        
        
        syncFromGrid() {
            const recs = (w2ui.positions?.records || []);
            this.gridRecords = recs.map(r => ({ ...r }));
            
            const curIds = recs.map(r => String(r.currency_id ?? r.currency ?? '1'));
            
            this.showUsd = curIds.includes('2');
            this.showEur = curIds.includes('3');
        },
        
        recalcTotals() {
            const rateFor = (curId) => {
                const id = String(curId ?? '1');
                if (id === '2') return Number(this.usdRate) || 0;
                if (id === '3') return Number(this.eurRate) || 0;
                return 1;
            };
            
            let sumUAH = 0;
            for (const r of this.gridRecords) {
                const s = Number(r.summ) || 0;
                if (!s) continue;
                sumUAH += s * rateFor(r.currency_id ?? r.currency);
            }
            
            let pdvRate = 0;
            
            if (parseInt(this.pdvType) === 1) pdvRate = 0.20;
            else if (parseInt(this.pdvType) === 2) pdvRate = 0.14;
            else if (parseInt(this.pdvType) === 3) pdvRate = 0.07;
            
            const pdv   = sumUAH * pdvRate;
            const total = sumUAH + pdv;
            
            this.totals = { sumUAH, pdv, total };
        },
        
        async loadPositions() {
            this.is_loading = true;
            await api.get('/tenders/list/' +this.tender.id +'/applications/'+ this.tender.app_id +'/positions').then(({data}) => {
                this.is_loading = false;
                if (data.status === "operation_success") {
                    
                    this.positions = data.data || []
                    w2ui.positions.records = this.positions
                    w2ui.positions.refresh()
                    
                    this.calcParams();
                }
            }).catch(response => {
                this.is_loading = false;
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        fmtUA(v) { return (Math.round((Number(v)||0)*100)/100).toLocaleString('uk-UA',{minimumFractionDigits:2,maximumFractionDigits:2}) },
        
    },
    
    computed : {
        ...mapGetters({
            'user': "user/getUser",
        }),
        
        
        request() {
            return this.tender.request;
        },
        
        pdvType() {
            return this.request.has_pdv;
        },
        usdRate() {
            return this.request.usd_exchange_rate;
        },
        
        eurRate() {
            return this.request.eur_exchange_rate;
        },
        toolBar() {
        
        }
    }
}
</script>



<style scoped>
.height38 {
    min-height: 43px;
    padding-top: 5px;
}
</style>